// extracted by mini-css-extract-plugin
module.exports = {"root":"Layout_root__SwKo-","main":"Layout_main__1eDAp","skip":"Layout_skip__3JfBY"};